"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ImageUpload_1 = require("./ImageUpload");
(function (w, $) {
    if (!$)
        return false;
    var imageUploadExtensions = {
        imageUpload: function () {
            return this.each(function () {
                var obj = $(this);
                new ImageUpload_1.ImageUpload(obj);
            });
        }
    };
    $.fn.extend(imageUploadExtensions);
})(window, $);
